import baseAPI from '@/api/base';
import { EditEmployee, GetEmployee, GetEmployeeActivity, GetEmployeeDirectory, RegisterEmployee } from '@/dtos/employee.dto';
import {
  DELETE_EMPLOYEE_URL,
  EDIT_EMPLOYEE_URL,
  GET_EMPLOYEE_ACTIVITY_URL,
  GET_EMPLOYEE_DIRECTORY_URL,
  GET_EMPLOYEE_STATS_URL,
  GET_EMPLOYEE_URL,
  INVITE_EMPLOYEE_URL,
  REGISTER_EMPLOYEE_URL,
  TOGGLE_EMPLOYEE_IS_ACTIVE_URL,
  UPLOAD_EMPLOYEE_PROFILE_PHOTO_URL,
} from '@/utils/urls';
import { AxiosResponse } from 'axios';

class Employee {
  static getEmployees = async (getEmployee: GetEmployee): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_EMPLOYEE_URL, {
      params: getEmployee,
    });
    console.log('response', response);
    return response;
  };

  static getEmployeeDirectory = async (params: GetEmployeeDirectory): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_EMPLOYEE_DIRECTORY_URL, {
      params,
    });
    return response;
  };

  static getEmployeeActivity = async ({ id, ...params }: GetEmployeeActivity): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(`${GET_EMPLOYEE_ACTIVITY_URL}/${id}/activity`, {
      params,
    });
    return response;
  };

  static getEmployeeStats = async (getEmployee: GetEmployee): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(
      `${GET_EMPLOYEE_STATS_URL}/${getEmployee.id}`
    );
    console.log('response', response);
    return response;
  };

  static registerEmployee = async (
    registerEmployee: RegisterEmployee
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(REGISTER_EMPLOYEE_URL, {
      ...registerEmployee,
    });
    console.log('response', response);
    return response;
  };

  static editEmployee = async (editEmployee: EditEmployee): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(EDIT_EMPLOYEE_URL, {
      ...editEmployee,
    });
    return response;
  };

  static inviteEmployee = async (userId: string): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(
      `${INVITE_EMPLOYEE_URL}/${userId}`
    );
    return response;
  };

  static toggleEmployeeIsActive = async (
    editEmployee: EditEmployee
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(
      TOGGLE_EMPLOYEE_IS_ACTIVE_URL,
      {
        ...editEmployee,
      }
    );
    return response;
  };

  static deleteEmployee = async (userId: string): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(
      `${DELETE_EMPLOYEE_URL}/${userId}`
    );
    return response;
  };

  static uploadProfilePhoto = async (
    employeeId: string,
    formData: FormData | null
  ): Promise<AxiosResponse> => {
    // If formData is null, send it as null to delete the photo
    const data = formData || null;
    const headers = formData
      ? { 'Content-Type': 'multipart/form-data' }
      : { 'Content-Type': 'application/json' };

    const response: AxiosResponse = await baseAPI.patch(
      `${UPLOAD_EMPLOYEE_PROFILE_PHOTO_URL}/${employeeId}/profilePhoto`,
      formData ? formData : { file: null },
      {
        headers: headers,
      }
    );
    return response;
  };
}

export default Employee;
